import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { Image } from 'antd'
import { graphql, Link } from 'gatsby'

import { Seo } from '../components/seo'
import useTranslations from '../utils/translations'

const Section = styled.section`
    ${tw`px-12 lg:px-40 py-12 pt-7 lg:pt-14`}
`
const H31 = styled.h3`
    ${tw`text-6xl font-bold tracking-widest leading-normal md:leading-relaxed`}
`
const Content = styled.div`
    ${tw`flex flex-wrap md:flex-row`}
`
const List = styled.div`
    ${tw`w-full lg:w-1/2 p-2`}
`
const Card = styled.div`
    ${tw`flex flex-col lg:flex-row rounded overflow-hidden h-auto lg:h-56 shadow`}
`
const Img = styled.div`
    ${tw`flex items-center p-2 h-auto w-full lg:w-2/5 flex-none`}
`
const Rows = styled.div`
    ${tw`rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal`}
`
const Row = styled.div`
    ${tw`tracking-wide lg:tracking-normal`}
`
const P = styled.div`
    ${tw`text-base leading-normal md:leading-normal tracking-normal font-bold pb-2`}
`
const P1 = styled.p`
    ${tw`text-xs tracking-wider font-light`}
`
const Button = styled.button`
    ${tw`border text-xs font-normal border-gray-300 border-2 rounded-md py-1 px-2 text-black hover:text-white hover:bg-black`}
`

const WorkPage = ({ data: { allMdx } }) => {
    const { work_title, project_technology, project_visit_button } = useTranslations()

    return (
        <>
            <Seo title={"Jundana Al-Basyir | Work"} />
            <Section>
                <H31>{work_title}</H31>
                <Content>
                    {allMdx.edges && allMdx.edges.map((item, i) => {
                        let work = item.node.frontmatter
                        return (
                            <List key={i}>
                                <Card>
                                    <Img>
                                        <Image src={work.thumbnailImage.childImageSharp.fluid.src} />
                                    </Img>
                                    <Rows>
                                        <Row>
                                            <P>{work.title}</P>
                                            <P1>{work.description}</P1>
                                            <P1>{project_technology}
                                                {work.categories.map((category, i) => {
                                                    return (
                                                        <span style={{ fontWeight: 500 }}>
                                                            {(work.categories.length < 2 ? ' ' : ((work.categories.length === i + 1) ? ' & ' : (i ? ', ' : ' '))) + category}
                                                        </span>
                                                    )
                                                })}.
                                            </P1>
                                        </Row>
                                        <Link to={work.path} target="_blank" rel="noopener noreferrer">
                                            <Button>{project_visit_button}</Button>
                                        </Link>
                                    </Rows>
                                </Card>
                            </List>
                        )
                    })}
                </Content>
            </Section>
        </>
    )
}

export default WorkPage

export const query = graphql`
query HomePage($locale: String!) {
    allMdx(
        filter: {fields: {locale: {eq: $locale}}, frontmatter: {type: {eq: "work"}} }
        sort: { fields: [frontmatter___date], order: DESC }
    ) {
        edges {
            node {
                frontmatter {
                    path
                    thumbnailImage {
                        childImageSharp {
                            fluid {
                                ...GatsbyImageSharpFluid
                            }
                        }
                    }
                    type
                    title
                    categories
                    date(fromNow: true)
                    description
                }
                fields {
                    locale
                }
            }
        }
    }
}`